import { render, staticRenderFns } from "./BackgroundTris.vue?vue&type=template&id=962d3efc"
import script from "./BackgroundTris.vue?vue&type=script&lang=ts"
export * from "./BackgroundTris.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports